import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import { SECTIONS } from './resourcesData';
const TABS = [['all', 'All', 'fas fa-th-large'], ...SECTIONS.map(s => [s.key, s.title, s.icon])];
const POPULAR = ['Tax', 'Salary', 'NGX', 'Naira', 'States', 'Governors', 'Japa', 'Cost of living'];
// tab names before the October 2026 regrouping, so old links still land somewhere sensible
const OLD_TABS = {
  tools: 'money',
  diaspora: 'abroad',
  general: 'abroad'
};
const go = (e, url) => {
  if (!url || /^https?:/.test(url) || e.ctrlKey || e.metaKey) return;
  e.preventDefault();
  m.route.set(url);
};

/** /resources: the same layout and styling as the Data Hub home (hero, search, tabs, cards). */
export default class ResourcesPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);
    this.bodyClass = 'DataHubFull';
    const asked = m.route.param('tab');
    const wanted = OLD_TABS[asked] || asked;
    this.tab = TABS.some(t => t[0] === wanted) ? wanted : 'all';
    this.query = m.route.param('q') || '';
    app.setTitle('Resources');
  }
  view() {
    const q = this.query.trim().toLowerCase();
    const words = q.split(/\s+/).filter(Boolean);
    const sections = SECTIONS.filter(s => q || this.tab === 'all' || s.key === this.tab).map(s => ({
      ...s,
      cards: s.cards.filter(c => !words.length || words.every(w => (c.title + ' ' + c.desc + ' ' + s.title).toLowerCase().includes(w)))
    })).filter(s => s.cards.length);
    return m("div", {
      className: "DataHubFull-page ResPage"
    }, m("section", {
      className: "DHHero"
    }, m("div", {
      className: "container DHHero-inner"
    }, m("div", {
      className: "DHHero-text"
    }, m("div", {
      className: "DHHero-eyebrow"
    }, "Resources"), m("h1", null, "Tools and data"), m("p", null, "Calculators, market prices, Nigeria's data and tools for moving abroad."), m("form", {
      className: "DHHero-search",
      onsubmit: e => e.preventDefault()
    }, m("i", {
      className: "fas fa-search",
      "aria-hidden": "true"
    }), m("input", {
      type: "search",
      placeholder: "Search tools, calculators and data\u2026",
      value: this.query,
      oninput: e => this.query = e.target.value,
      "aria-label": "Search resources"
    }), m("button", {
      type: "submit",
      className: "Button Button--primary"
    }, "Search")), m("div", {
      className: "DHHero-popular"
    }, m("span", null, "Popular:"), POPULAR.map(p => m("button", {
      className: 'DHChip' + (this.query.toLowerCase() === p.toLowerCase() ? ' is-active' : ''),
      onclick: () => this.query = p
    }, p)))))), m("div", {
      className: "container"
    }, m("nav", {
      className: "DHTabs",
      "aria-label": "Resource categories"
    }, TABS.map(([key, label, icon]) => m("button", {
      className: 'DHTab' + (this.tab === key && !q ? ' is-active' : ''),
      onclick: () => {
        this.tab = key;
        this.query = '';
      }
    }, m("i", {
      className: icon,
      "aria-hidden": "true"
    }), m("span", null, label)))), q ? m("div", {
      className: "DHSection-head ResResults"
    }, m("h2", null, "Results for \"", this.query.trim(), "\""), m("button", {
      className: "DHLink",
      onclick: () => this.query = ''
    }, "Clear search")) : null, sections.length ? sections.map(s => m("section", {
      className: "DHSection"
    }, m("div", {
      className: "DHSection-head"
    }, m("div", null, m("h2", null, m("i", {
      className: s.icon + ' ResSection-icon',
      "aria-hidden": "true"
    }), " ", s.title), m("p", {
      className: "DHMuted"
    }, s.sub))), m("div", {
      className: "ResCards"
    }, s.cards.map(c => this.card(c))))) : m("p", {
      className: "DHMuted ResEmpty"
    }, "Nothing matches \"", this.query.trim(), "\". Try another word, or browse the tabs above.")));
  }
  card(c) {
    const inner = [m("span", {
      className: 'ResCard-icon is-' + c.color,
      "aria-hidden": "true"
    }, c.icon), m("span", {
      className: "ResCard-text"
    }, m("strong", null, c.title), m("small", null, c.soon ? 'Coming soon' : c.desc)), m("i", {
      className: 'ResCard-go fas ' + (c.soon ? 'fa-clock' : c.external ? 'fa-external-link-alt' : 'fa-chevron-right'),
      "aria-hidden": "true"
    })];
    if (c.soon) return m("div", {
      className: "ResCard is-soon"
    }, inner);
    return m("a", {
      className: "ResCard",
      href: c.href,
      target: c.external ? '_blank' : undefined,
      rel: c.external ? 'noopener' : undefined,
      onclick: e => go(e, c.external ? null : c.href)
    }, inner);
  }
}